import http from './reddit'
import qs from 'qs'

// const version = {
//   upNavData: { all: 'linkuptd', self: 'uptd' }
// }

export default {
  // 取得 遊戲是否開關列表
  gameSwitchList: (gameid) => http.Get(`${http.url.hfl}/oddisstop/${gameid}`),
  /**------现场监督(自己)---------**/
  /**现场监督 上面遊戲按鈕內數據*/
  upNavData: (gameid) => http.Get(`${http.url.six}/uptd/${gameid}`),              
  fixBacoOdds: (gameid, data) => http.Post(`${http.url.six}/allupchodd/${gameid}`, data),                                    //現場監督_整體_改變賠率佔成
  fixBacoOddsPerson: (gameid, data) => http.Post(`${http.url.six}/supododup/${gameid}`, data),                              //現場監督_個別_改變賠率佔成
  fixBetcallist: (data) => http.Post(`${http.url.Newcommon}/canres`, data),
  supodod: ({ gameid, page, odd, baco }) => http.Get(`${http.url.six}/supodod/${gameid}/${page}/${odd}/${baco}`),   // 现场监督 {baco: "A, B 盘口"}
  supodods: ({ gameid, page, odd, baco, next }) => http.Get(`${http.url.six}/supodods/${gameid}/${page}/${odd}/${baco}`),    // 現場監督右排序 {next: {0: 前25 1: 后25}}
  supododtwo: ({ gameid, page, odd, baco }) => http.Get(`${http.url.six}/supododtwo/${gameid}/${page}/${odd}/${baco}`),  //現場監督_组合碼_頁面 盘口: A,B
  stopclname: (gameid) => http.Get(`${http.url.six}/stopclname/${gameid}`),                                                                 //現場監督_非特碼_停押開關列表
  stopclnamepost: (gameid, data) => http.Post(`${http.url.six}/eplastop/${gameid}`, data),

 /**------现场监督(各站点)---------**/
  AllupNavData: (gameid, id = 0) => http.Get(`${http.url.six}/linkuptd/${gameid}/${id}`),
  linksupodod: ({ gameid, page, odd, baco, site }) => http.Get(`${http.url.six}/linksupodod/${gameid}/${site}/${page}/${odd}/${baco}`),
  linksupodods: ({ gameid, page, odd, baco, next, site }) => http.Get(`${http.url.six}/linksupodods/${gameid}/${site}/${page}/${odd}/${baco}`),
  linksupododtwo: ({ gameid, page, odd, baco, site }) => http.Get(`${http.url.six}/linksupododtwo/${gameid}/${site}/${page}/${odd}/${baco}`), 
  linksupododup: (gameid, data) => http.Post(`${http.url.six}/linksupododup/${gameid}`, data),
  linkallupchodd: (gameid, data) => http.Post(`${http.url.six}/linkallupchodd/${gameid}`, data),
  linkstid: () => http.Get(`${http.url.six}/linkstid`),
  linkmytlpa: (id = 0) => http.Get(`${http.url.six}/linkmytlpa/${id}`),

  // 生肖表
  yzodod: () => http.Get(`${http.url.six}/yzodod`),
  // 12重肖值
  blackreqyzo: (gameid) => http.Get(`${http.url.six}/blackreqyzo/${gameid}`),
  // 快速操盤玩法列表
  quickoddsplaylist: (params) => http.Get(`${http.url.six}/quicksupodod?${qs.stringify(params)}`),
  // 快速操盤
  quickoddsplay: (data) => http.Post(`${http.url.six}/quicksupododup`, data),
  // 快速操盤折扣模板
  quickoddsmodel: () => http.Get(`${http.url.six}/quicksupodod_model`),
  // 新增快速操盤折扣模板
  addquickoddsmodel: (data) => http.Post(`${http.url.six}/quicksupodod_model_add`, data),
  // 修改快速操盤模板
  updquickoddsmodel: (data) => http.Post(`${http.url.six}/quicksupodod_model_upd`, data),

  jumpTimeData: (gameid, data) => http.Get(`${http.url.six}/autodownpp_time/${gameid}?${qs.stringify(data, { encode: false })}`),
  // 標記
  analyze: () => http.Get(`${http.url.six}/analyze`),
  // 修改標記
  analyzeupd: (data) => http.Post(`${http.url.six}/analyzeupd`, data),

}